import { FilterGroup } from '../Tools/FilterGroup';
import { BathroomTypeFilter } from '../Filters/BathroomTypeFilter';
import { ObjectTypeFilter } from '../Filters/ObjectTypeFilter';
import { GenericElement } from '../Elements/GenericElement';
import { FiltersWidget } from '../FiltersWidget';
import { FiltersController } from '../Tools/FiltersController';
declare var AssetManagerServices: any;
export class BathRoomFilterWidget extends FilterGroup {
    constructor(container: string, bathroomElements: GenericElement[]) {
        super();
        this.id = 'bathroom';
        this.name = 'Salle de bain';
        this.icon = 'fas fa-lg fa-bath';
        this.resource = 'assets';
        this.filtersFunction = 'updateFilters';
        this.filters = [
            new BathroomTypeFilter(bathroomElements, this),
            new ObjectTypeFilter(this)
        ]
        this.container = container;
        this.controller = new FiltersController();
    }

    static getInstance(): BathRoomFilterWidget | null {
        if (!FiltersWidget.filterGroups || FiltersWidget.filterGroups.length === 0) return null;
        return FiltersWidget.filterGroups.find((filterGroup: FilterGroup) => filterGroup.id === 'bathroom') as BathRoomFilterWidget || null;
    }

    generateStringFilter() {
        var i: number;
        let stringFilters = super.generateStringFilter();
        let filters = FilterGroup.filters;

        if (filters.style !== null && filters.style.length > 0) {
            stringFilters += '&q.styles._id.in=';
            for (i = 0; i < filters.style.length; i++) {
                if (i > 0) {
                    stringFilters += ',';
                }
                stringFilters += filters.style[i]._id;
            }
        }

        if (filters.roomType !== null && filters.roomType.length > 0) {
            stringFilters += '&q.environment.roomTypes.in=';
            for (i = 0; i < filters.roomType.length; i++) {
                if (i > 0) {
                    stringFilters += ',';
                }
                stringFilters += filters.roomType[i]._id;
            }
        }

        if (Array.isArray(filters.name)) {
            if (filters.name.length > 0) {
                if (FilterGroup.smartSearch()) {
                    stringFilters += '&filter=' + filters.name.join(',');
                }
                else {
                    if (filters.sort && (filters.sort.price > 0 || filters.sort.width > 0)) {
                        stringFilters += '&q.labels.lk=' + filters.name.join(',');
                    }
                    else {
                        stringFilters += '&text=' + filters.name.join(',');
                    }
                }
            }
        }
        else if (filters.name) {
            if (FilterGroup.smartSearch()) {
                stringFilters += '&filter=' + filters.name;
            }
            else {
                if (filters.sort && (filters.sort.price > 0 || filters.sort.width > 0)) {
                    stringFilters += '&q.labels.lk=' + filters.name;
                }
                else {
                    stringFilters += '&text=' + filters.name;
                }
            }
        }

        let result = FilterGroup.initSortArray();
        stringFilters += result.stringFilter;
        let sort: any[] = result.sort;

        if (sort.length > 0) {
            stringFilters += '&sort=' + sort.join(',');
        }
        // We only want non kitchen fab objects
        if (!FiltersWidget.getDecorationService().displayGroups) {
            stringFilters += '&q.pipeline.modelState.eq=validated';
            stringFilters += '&q.pipeline.unrealState.eq=ready';
        }

        if (FilterGroup.filters.assets && FilterGroup.filters.assets.length > 0) {
            stringFilters += '&q._id.in=' + FilterGroup.filters.assets;
        }
        return stringFilters;
    };

    update(): void {
        this.destroy();
        this.html();
    }

    selectionListener: () => void;

    html(): void {
        this.isDestroyed = false;
        this.loadAllAssets().then(() => {
            this.selectionListener = () => { this.updateAllActiveLists(); };
            FilterGroup.addEntitySelectionListener(this.selectionListener);
            let html = this.filtersHtml() + `
            <div>
                <h style="font-weight:600;">Personnalisation Lapeyre Forméo</h>
                <div class="padding">
                    <div style="display:contents" id="Caisson-parent">
                        ${this.CaissonHtml()}
                    </div>
                    <div style="display:contents" id="Chant-parent">
                        ${this.ChantHtml()}
                    </div>
                    <div style="display:contents" id="Poignee-parent">
                        ${this.PoigneeHtml()}
                    </div>
                </div>
            </div>
            `;
            let container = document.getElementById(this.container);
            if (!container) {
                return;
            }
            container.innerHTML = html;
        });
    }

    loadAllAssets(): Promise<void[]> {
        let doorPromise = this.getAllDoor();
        let MirrorPromise = this.getAllMirror();
        let handlePromise = this.getAllHandleModels();
        return Promise.all([doorPromise, MirrorPromise, handlePromise]);
    }

    getAllDoor(): Promise<void> {
        let promise = new Promise<void>((resolve, reject) => {
            if (FilterGroup.allLapeyreFormeoCabinetCoatings.length !== 0) {
                resolve();
                return;
            }
            AssetManagerServices.getAssets(AssetManagerServices._ASSET_TYPE.COATINGS, FiltersWidget.OPTIMIZED_DB_FIELDS_FOR_ARRANGEMENTS + '&q.customizationGroups.name.in=CG_LAPEYRE_FORMEO_COLORIS&q.pipeline.state.eq=available&q.pipeline.modelState.eq=validated&sort=name', function (res) {
                var resources = res.data.resources;
                if (resources !== undefined && resources !== null && resources.length > 0) {
                    FilterGroup.allLapeyreFormeoCabinetCoatings = resources;
                    resolve();
                } else {
                    reject('No resources found for Lapeyre Formeo cabinet coatings');
                }
            });
        });
        return promise;
    }

    getAllMirror(): Promise<void> {
        let promise = new Promise<void>((resolve, reject) => {
            if (FilterGroup.allLapeyreFormeoMirrorCoatings.length !== 0) {
                resolve();
                return;
            }
            AssetManagerServices.getAssets(AssetManagerServices._ASSET_TYPE.COATINGS, FiltersWidget.OPTIMIZED_DB_FIELDS_FOR_ARRANGEMENTS + '&q.customizationGroups.name.in=CG_LAPEYRE_FORMEO_COLORIS,CG_LAPEYRE_FORMEO_COLORIS_MIROIRS&q.pipeline.state.eq=available&q.pipeline.modelState.eq=validated&sort=name', function (res) {
                var resources = res.data.resources;
                if (resources !== undefined && resources !== null && resources.length > 0) {
                    FilterGroup.allLapeyreFormeoMirrorCoatings = resources;
                    resolve();
                } else {
                    reject('No resources found for Lapeyre Formeo mirror coatings');
                }
            });
        });
        return promise;
    }

    getAllHandleModels(): Promise<void> {
        let promise = new Promise<void>((resolve, reject) => {
            if (FilterGroup.allLapeyreFormeoHandleModels.length !== 0) {
                resolve();
                return;
            }
            AssetManagerServices.getHandles(FiltersWidget.OPTIMIZED_DB_FIELDS_FOR_ARRANGEMENTS + '&sort=name&q.pipeline.state.eq=available&q.pipeline.modelState.eq=validated&q.manufacturer.eq=5eba5c37f3c97d07e6f83b5e', '6793a50125716ef37a5cc007,5f6b6699e9de7056bb9155d1', function (res) {
                var resources = res.data.resources;
                if (resources !== undefined && resources !== null && resources.length > 0) {
                    FilterGroup.allLapeyreFormeoHandleModels = resources;
                    resolve();
                } else {
                    reject('No resources found for Lapeyre Formeo handle models');
                }
            });
        });
        return promise;
    }

    updateActive(objects: any[], customName: string, isHandle?: boolean) {
        objects.forEach((object) => {
            FilterGroup.cache.name = "";
            let isActive: boolean;
            if (isHandle) isActive = FilterGroup.isHandleUsed(object, FiltersWidget.ArrangementType.bathroomCustomizableArrangements);
            else isActive = FilterGroup.isCoatingUsed(object, customName, FiltersWidget.ArrangementType.bathroomCustomizableArrangements);

            let display = isActive ? "" : "none";
            $(`#active-${object.name}-${customName}`).css('display', display);
        })
    }

    updateAllActiveLists() {
        this.updateActive(FilterGroup.allLapeyreFormeoCabinetCoatings, 'Caisson');
        this.updateActive(FilterGroup.allLapeyreFormeoMirrorCoatings, 'Chant');
        this.updateActive(FilterGroup.allLapeyreFormeoHandleModels, "Poignee", true);
    }

    getGenericHtml(coatings: any[], customName: string, getPreviewUrl: (coating: any) => string, title: string): string {
        let coatingsHtml = coatings.map((coating: any) => {
            setTimeout(() => {
                let listener = () => {
                    FilterGroup.updateArrangementCoating(coating, customName, FiltersWidget.ArrangementType.bathroomCustomizableArrangements);
                    this.updateActive(coatings, customName);
                }

                this.controller.addEventListener('click', listener, `div-${coating.name}-${customName}`);
                this.controller.addEventListener('click', listener, `img-${coating.name}-${customName}`);
            }, 50);

            const isUsed = FilterGroup.isCoatingUsed(coating, customName, FiltersWidget.ArrangementType.bathroomCustomizableArrangements);

            return `
                <div style="cursor: pointer;display:inline-block;width:50px;height:50px;position:relative">
                    <div style="position:absolute;top:0px;left:0px;width:50px;height:50px;background-color:#f5d23100;"
                        title="${coating.name}" id="div-${coating.name}-${customName}">
                    </div>
                    <img style="width:50px;height:50px;" id="img-${coating.name}-${customName}" 
                        src="${getPreviewUrl(coating)}">
                    <div id="active-${coating.name}-${customName}" style="position:absolute;top:0;left:0;height:11px;cursor:pointer;font-size:20px;color:rgb(0, 192, 0);${isUsed ? '' : 'display:none'}">
                        <i class="glyphicon glyphicon-ok"></i>
                    </div>
                </div>
                `;
        }).join('');

        return `
        <div style="text-align: left;">${title}</div>
        <div
            style="margin-bottom:10px;padding:0;width: 100%;white-space: nowrap;overflow-x:auto;overflow-y:hidden">
            ${coatingsHtml}
        </div>
        `;
    }

    CaissonHtml(): string {
        return this.getGenericHtml(
            FilterGroup.allLapeyreFormeoCabinetCoatings,
            'Caisson',
            FilterGroup.getCabinetCoatingPreviewUrl,
            'Caissons/Portes'
        );
    }

    ChantHtml(): string {
        return this.getGenericHtml(
            FilterGroup.allLapeyreFormeoMirrorCoatings,
            'Chant',
            FilterGroup.getCabinetCoatingPreviewUrl,
            'Bords de miroir'
        );
    }

    PoigneeHtml(): string {
        let handlesHtml = FilterGroup.allLapeyreFormeoHandleModels.map((modele: any) => {
            setTimeout(() => {
                let listener = () => {
                    FilterGroup.updateArrangementHandleModeleType(modele, FiltersWidget.ArrangementType.bathroomCustomizableArrangements).then(() => {
                        this.updateActive(FilterGroup.allLapeyreFormeoHandleModels, "Poignee", true);
                    });
                }
                this.controller.addEventListener('click', listener, `div-${modele.name}-Poignee`);
                this.controller.addEventListener('click', listener, `img-${modele.name}-Poignee`);
            }, 50);

            let isUsed = FilterGroup.isHandleUsed(modele, FiltersWidget.ArrangementType.bathroomCustomizableArrangements);
            return `
            <div style="cursor: pointer;display:inline-block;width:50px;height:50px;position:relative">
                <div id="div-${modele.name}-Poignee"
                style="position:absolute;top:0px;left:0px;width:50px;height:50px;background-color:#f5d23100;" title="${modele.name}">
                </div>
                <img id="img-${modele.name}-Poignee" style="width:50px;height:50px;" src="${FilterGroup.getHandlePreviewUrl(modele)}">
                <div id="active-${modele.name}-Poignee" style="position:absolute;top:0;left:0;height:11px;cursor:pointer;font-size:20px;color:rgb(0, 192, 0);${isUsed ? '' : 'display:none'}">
                    <i class="glyphicon glyphicon-ok"></i>
                </div>
            </div>
        `;
        }).join('');

        setTimeout(() => {
            let listener = () => {
                FilterGroup.removeArrangementHandleModel(FiltersWidget.ArrangementType.bathroomCustomizableArrangements);
                this.updateActive(FilterGroup.allLapeyreFormeoHandleModels, "Poignee", true);
            }
            this.controller.addEventListener('click', listener, 'NoHandle');
        }, 50);

        return `
        <div style="text-align: left;">Poignées</div>
        <div style="margin-bottom:10px;padding:0;width:100%;white-space: nowrap;overflow-x:auto;overflow-y:hidden">
            ${handlesHtml}
            <div id="NoHandle" title="Pas de poignée" style="cursor: pointer;display:inline-block;width:50px;height:50px;position:relative">
                <i class="far fa-2x fa-trash-alt" style="vertical-align: middle;"></i>
            </div>
        </div>
        `;
    }

    destroy(): void {
        super.destroy();
        if (this.selectionListener) {
            FilterGroup.removeEntitySelectionListener(this.selectionListener);
            this.selectionListener = undefined;
        }
    }
}